Ext.define('SA.AttributeBadges', {
    singleton: true,

    forYear(attribute) {
        if (SA.data.AttributesCache.isEstimate(attribute)) {
            return this.getBadgeHtml({text: 'est', tooltipHtml: 'Estimated data variable'});
        }
        else if (SA.data.AttributesCache.isProjection(attribute)) {
            return this.getBadgeHtml({text: 'proj', tooltipHtml: 'Projected data variable'});
        }

        return '';
    },

    getBadgeHtml({text, tooltipHtml}) {
        return SA.Tags.html`<span class="sa-attribute-badge" data-attribute-badge-tooltip-html="${tooltipHtml}">${text}</span>`;
    },

    getHtml({attribute, includeDatasetAbbreviation = true}) {
        var {dataset_series: dataset, vendor} = SA.data.AttributesCache.get(attribute),
            abbreviation = SA.data.DatasetAbbreviations.all[dataset],
            yearBadge = this.forYear(attribute),
            html = [];

        if (includeDatasetAbbreviation && abbreviation) {
            html.push(this.getBadgeHtml({
                text: abbreviation,
                tooltipHtml: SA.Tags.html`<strong>Dataset: </strong>${SA.data.Datasets.getName(dataset)}<br><strong>Vendor: </strong>${vendor}`
            }));
        }

        if (yearBadge) {
            html.push(yearBadge);
        }

        return `<span>${html.join(' ')}</span>`;
    },

    getText({attribute}) {
        var text = '';

        if (SA.data.AttributesCache.isEstimate(attribute)) {
            text += ' [Estimated]';
        }
        else if (SA.data.AttributesCache.isProjection(attribute)) {
            text += ' [Projected]';
        }

        return text;
    },

    initialize() {
        addEventListener('mouseover', ({target}) => {
            if (target.hasAttribute('data-attribute-badge-tooltip-html')) {
                new SA.Tooltip({content: target.getAttribute('data-attribute-badge-tooltip-html'), target});
            }
        });
    }
});